module.exports = __webpack_public_path__ + "static/img/Joel_Selwood_desktop.9a3d25e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joel_Selwood_desktop.jpg
// module id = PiS5
// module chunks = 0